export default __webpack_public_path__ + "static/media/5.ea10d00f.png";